
            export default class {
              constructor() {
                return new Worker('./TaskRunner.worker.js');
              }
            }